import api from 'lib/Api'
import * as types from '../../actionTypes'

const intitialState = {
  isLoading: false,
  roles: [],
}

export const fetchingRoles = () => ({
  type: types.FETCHING_ROLES,
})

export const fetchingRolesError = () => {
  return {
    type: types.FETCHING_ROLES_ERROR,
    error: 'Error fetching Roles',
  }
}

export const fetchingRolesSuccess = roles => {
  return {
    type: types.FETCHING_ROLES_SUCCESS,
    roles,
  }
}

export const fetchAndHandleRoles = () => {
  return async function (dispatch) {
    dispatch(fetchingRoles())

    try {
      const response = await api.get('/admin/roles')
      dispatch(fetchingRolesSuccess(response.data))
    } catch {
      dispatch(fetchingRolesError())
    }
  }
}

export default (state = intitialState, action) => {
  switch (action.type) {
    case types.FETCHING_ROLES:
      return {
        ...state,
        isLoading: true,
      }
    case types.FETCHING_ROLES_SUCCESS:
      const formattedRoles = action.roles.map(role => {
        role.value = role.roleId
        role.label = role.roleName
        return role
      })
      return {
        ...state,
        isLoading: false,
        roles: formattedRoles,
      }
    case types.FETCHING_ROLES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      }
    default:
      return state
  }
}
